/* Alakh Nagri — theme behaviour */
(function () {
  'use strict';

  var ROUTES = window.AlakhRoutes || {};
  var STRINGS = window.AlakhStrings || {};
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), summary, [tabindex]:not([tabindex="-1"])';

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ---------------- Reveal on scroll ---------------- */
  function initReveal(root) {
    var items = $$('.an-reveal:not(.is-visible)', root || document);
    if (!items.length) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var delay = parseInt(el.getAttribute('data-reveal-index') || '0', 10) * 70;
        setTimeout(function () { el.classList.add('is-visible'); }, delay);
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -60px 0px', threshold: 0.01 });
    items.forEach(function (el) { io.observe(el); });
  }

  /* Safety net: if JS runs but the observer never fires, reveal after 3s */
  setTimeout(function () { $$('.an-reveal:not(.is-visible)').forEach(function (el) { el.classList.add('is-visible'); }); }, 3000);

  /* ---------------- Focus trap helper ---------------- */
  function TrapController(container) {
    this.container = container;
    this.opener = null;
    this.onKey = this.onKey.bind(this);
  }
  TrapController.prototype.focusables = function () {
    return $$(FOCUSABLE, this.container).filter(function (el) {
      return el.offsetParent !== null || el.getClientRects().length;
    });
  };
  TrapController.prototype.activate = function (opener) {
    this.opener = opener || document.activeElement;
    document.addEventListener('keydown', this.onKey);
    /* Pitfall #9: the overlay carries data-drawer-close but is not focusable.
       Pick the first genuinely focusable element instead. */
    var list = this.focusables();
    var target = list[0];
    if (target) { setTimeout(function () { target.focus(); }, 60); }
  };
  TrapController.prototype.deactivate = function () {
    document.removeEventListener('keydown', this.onKey);
    if (this.opener && typeof this.opener.focus === 'function') this.opener.focus();
    this.opener = null;
  };
  TrapController.prototype.onKey = function (e) {
    if (e.key !== 'Tab') return;
    var list = this.focusables();
    if (!list.length) return;
    var first = list[0], last = list[list.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  };

  /* ---------------- Generic overlay component ---------------- */
  function Overlay(el) {
    if (!el) return;
    this.el = el;
    this.trap = new TrapController(el);
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
    var self = this;
    /* Delegated, not bound per button. The cart drawer replaces its own inner
       HTML after every add/update, which would wipe listeners bound directly
       to the close button and leave the drawer impossible to dismiss. */
    el.addEventListener('click', function (e) {
      var hit = e.target.closest ? e.target.closest('[data-drawer-close]') : null;
      if (!hit || !el.contains(hit)) return;
      e.preventDefault();
      self.close();
    });
    el.addEventListener('keydown', function (e) { if (e.key === 'Escape') self.close(); });
  }
  /* An overlay marked data-inline is not a modal: it expands in place and the
     page behind stays usable. Locking scroll and trapping focus there would
     make it behave like the takeover it is meant to replace, so both are
     skipped — Escape and click-outside still close it. */
  Overlay.prototype.open = function (opener) {
    this.el.classList.add('is-open');
    this.el.removeAttribute('aria-hidden');
    if (this.el.hasAttribute('data-inline')) {
      this.opener = opener || null;
      var field = this.el.querySelector('input, select, textarea, button');
      if (field) field.focus();
      return;
    }
    document.body.classList.add('an-locked');
    this.trap.activate(opener);
  };
  Overlay.prototype.close = function () {
    this.el.classList.remove('is-open');
    this.el.setAttribute('aria-hidden', 'true');
    if (this.el.hasAttribute('data-inline')) {
      if (this.opener && document.contains(this.opener)) this.opener.focus();
      this.opener = null;
      return;
    }
    document.body.classList.remove('an-locked');
    this.trap.deactivate();
  };

  var drawers = {};
  function registerOverlay(key, selector) {
    var el = $(selector);
    if (!el) return;
    /* The theme editor fires section:load repeatedly. Only rewrap when the
       element itself is new, otherwise listeners stack up. */
    if (drawers[key] && drawers[key].el === el) return;
    drawers[key] = new Overlay(el);
  }

  /* ---------------- Mega menu ---------------- */
  function initMegaMenu() {
    var items = $$('.an-catbar__item[data-has-panel]');
    var closeTimer;
    items.forEach(function (item) {
      if (item.dataset.megaBound) return;
      item.dataset.megaBound = '1';
      var trigger = $('.an-catbar__link', item);
      function open() {
        clearTimeout(closeTimer);
        items.forEach(function (i) { if (i !== item) { i.classList.remove('is-open'); var t = $('.an-catbar__link', i); if (t) t.setAttribute('aria-expanded', 'false'); } });
        item.classList.add('is-open');
        if (trigger) trigger.setAttribute('aria-expanded', 'true');
      }
      function close() {
        closeTimer = setTimeout(function () {
          item.classList.remove('is-open');
          if (trigger) trigger.setAttribute('aria-expanded', 'false');
        }, 140);
      }
      item.addEventListener('mouseenter', open);
      item.addEventListener('mouseleave', close);
      item.addEventListener('focusin', open);
      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) close();
      });
      if (trigger) {
        trigger.addEventListener('keydown', function (e) {
          if (e.key === 'Escape') { item.classList.remove('is-open'); trigger.setAttribute('aria-expanded', 'false'); trigger.focus(); }
        });
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      items.forEach(function (i) { i.classList.remove('is-open'); });
    });
  }

  /* ---------------- Quantity ---------------- */
  function initQuantity(root) {
    $$('[data-qty]', root || document).forEach(function (wrap) {
      if (wrap.dataset.qtyBound) return;
      wrap.dataset.qtyBound = '1';
      var input = $('input', wrap);
      if (!input) return;
      function clamp() {
        var min = parseInt(input.getAttribute('min') || '1', 10);
        var maxAttr = input.getAttribute('max');
        var max = maxAttr ? parseInt(maxAttr, 10) : null;
        var v = parseInt(input.value, 10);
        if (isNaN(v)) v = min;
        if (v < min) v = min;
        if (max !== null && v > max) v = max;
        input.value = v;
        return v;
      }
      $$('[data-qty-change]', wrap).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = parseInt(btn.getAttribute('data-qty-change'), 10);
          input.value = (parseInt(input.value, 10) || 1) + step;
          clamp();
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
      input.addEventListener('change', clamp);
      input.addEventListener('blur', clamp);
    });
  }

  /* ---------------- Variant picker ---------------- */
  function initVariantPickers(root) {
    $$('[data-product-form]', root || document).forEach(function (form) {
      if (form.dataset.variantBound) return;
      form.dataset.variantBound = '1';
      var dataEl = $('[data-variant-data]', form);
      if (!dataEl) return;
      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }

      var idInput = $('[data-variant-id]', form);
      var priceHost = $('[data-price-host]', form);
      var submit = $('[data-add-to-cart]', form);
      var submitText = submit ? $('[data-add-to-cart-text]', submit) : null;
      var sectionId = form.getAttribute('data-section-id');

      function selectedOptions() {
        return $$('[data-option-index]', form)
          .filter(function (el) { return el.checked || el.tagName === 'SELECT'; })
          .sort(function (a, b) { return a.getAttribute('data-option-index') - b.getAttribute('data-option-index'); })
          .map(function (el) { return el.tagName === 'SELECT' ? el.value : el.value; });
      }

      function matchVariant(opts) {
        for (var i = 0; i < variants.length; i++) {
          var ok = true;
          for (var j = 0; j < opts.length; j++) {
            if (variants[i].options[j] !== opts[j]) { ok = false; break; }
          }
          if (ok) return variants[i];
        }
        return null;
      }

      function markUnavailable(opts) {
        $$('[data-option-index]', form).forEach(function (el) {
          var idx = parseInt(el.getAttribute('data-option-index'), 10);
          var probe = opts.slice();
          probe[idx] = el.value;
          var found = variants.some(function (v) {
            for (var j = 0; j <= idx; j++) { if (v.options[j] !== probe[j]) return false; }
            return v.available;
          });
          var label = el.closest('label') || el.parentElement;
          if (label) label.classList.toggle('is-unavailable', !found);
        });
      }

      function syncGallery(variant) {
        if (!variant || !variant.featured_media) return;
        var slides = $$('[data-media-id]');
        slides.forEach(function (s) {
          var active = String(s.getAttribute('data-media-id')) === String(variant.featured_media);
          if (s.classList.contains('an-gallery__slide')) s.classList.toggle('is-active', active);
          if (s.classList.contains('an-gallery__thumb')) s.classList.toggle('is-active', active);
        });
      }

      function update() {
        var opts = selectedOptions();
        var variant = matchVariant(opts);
        markUnavailable(opts);

        if (idInput) idInput.value = variant ? variant.id : '';

        /* Pitfall #8: carry the full rendered price markup so the
           compare-at strikethrough survives a variant change. */
        if (priceHost && variant && variant.price_html) priceHost.innerHTML = variant.price_html;

        if (submit) {
          if (!variant) {
            submit.setAttribute('disabled', 'disabled');
            if (submitText) submitText.textContent = STRINGS.unavailable || 'Unavailable';
          } else if (!variant.available) {
            submit.setAttribute('disabled', 'disabled');
            if (submitText) submitText.textContent = STRINGS.soldOut || 'Sold out';
          } else {
            submit.removeAttribute('disabled');
            if (submitText) submitText.textContent = STRINGS.addToCart || 'Add to bag';
          }
        }

        syncGallery(variant);

        if (variant && window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }
        form.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: variant, sectionId: sectionId } }));
      }

      $$('[data-option-index]', form).forEach(function (el) {
        el.addEventListener('change', update);
        if (el.type === 'radio') {
          el.addEventListener('change', function () {
            $$('[data-option-index="' + el.getAttribute('data-option-index') + '"]', form).forEach(function (sib) {
              var lab = sib.closest('label');
              if (lab) lab.classList.toggle('is-selected', sib.checked);
            });
          });
        }
      });
      update();
    });
  }

  /* ---------------- Gallery ---------------- */
  function initGallery(root) {
    $$('[data-gallery]', root || document).forEach(function (gal) {
      if (gal.dataset.galleryBound) return;
      gal.dataset.galleryBound = '1';
      $$('.an-gallery__thumb', gal).forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var id = thumb.getAttribute('data-media-id');
          $$('.an-gallery__thumb', gal).forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
          $$('.an-gallery__slide', gal).forEach(function (s) {
            s.classList.toggle('is-active', s.getAttribute('data-media-id') === id);
          });
        });
      });
    });
  }

  /* ---------------- Cart ---------------- */
  function cartDrawerEl() { return $('#CartDrawer'); }

  function renderCartDrawer(html) {
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var fresh = parsed.querySelector('#CartDrawer');
    var current = cartDrawerEl();
    if (!fresh || !current) return;
    var wasOpen = current.classList.contains('is-open');
    var body = current.querySelector('[data-drawer-content]');
    var freshBody = fresh.querySelector('[data-drawer-content]');
    if (body && freshBody) body.innerHTML = freshBody.innerHTML;
    if (wasOpen) current.classList.add('is-open');
    bindCartDrawer();
    initQuantity(current);
    updateCartCountFromDom(current);
  }

  function updateCartCountFromDom(scope) {
    var badge = $('[data-cart-count]');
    var source = $('[data-cart-item-count]', scope || document);
    if (!badge || !source) return;
    var count = parseInt(source.getAttribute('data-cart-item-count'), 10) || 0;
    badge.textContent = count;
    if (count > 0) badge.removeAttribute('hidden'); else badge.setAttribute('hidden', 'hidden');
  }

  function errorBoxes(form) {
    /* Two elements carry [data-cart-error]: the buy box on a product page and
       the cart drawer. Picking the first in the DOM put the message in the
       wrong place depending on the template, so target the form's own box
       when there is one and always mirror it into the drawer, which opens. */
    var boxes = [];
    var local = form && form.closest ? form.closest('section, .an-pinfo') : null;
    if (local) { var b = $('[data-cart-error]', local); if (b) boxes.push(b); }
    var drawer = cartDrawerEl();
    if (drawer) { var d = $('[data-cart-error]', drawer); if (d && boxes.indexOf(d) === -1) boxes.push(d); }
    if (!boxes.length) { var any = $('[data-cart-error]'); if (any) boxes.push(any); }
    return boxes;
  }

  function showCartError(message, form) {
    var boxes = errorBoxes(form);
    if (!boxes.length) { window.alert(message); return; }
    boxes.forEach(function (box) {
      box.textContent = message;
      box.removeAttribute('hidden');
    });
  }
  function clearCartError() {
    $$('[data-cart-error]').forEach(function (box) {
      box.textContent = '';
      box.setAttribute('hidden', 'hidden');
    });
  }

  function fetchDrawerSection() {
    return fetch(ROUTES.cart_url + '?section_id=cart-drawer', { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(renderCartDrawer);
  }

  function bindCartDrawer() {
    var drawer = cartDrawerEl();
    if (!drawer) return;
    $$('[data-line-remove]', drawer).forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        changeLine(btn.getAttribute('data-line-key'), 0);
      });
    });
    $$('[data-line-qty]', drawer).forEach(function (input) {
      if (input.dataset.bound) return;
      input.dataset.bound = '1';
      input.addEventListener('change', function () {
        changeLine(input.getAttribute('data-line-key'), parseInt(input.value, 10) || 0);
      });
    });
  }

  function changeLine(key, quantity) {
    if (!key || !window.fetch) return;
    clearCartError();
    fetch(ROUTES.cart_change_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) { showCartError(res.data.description || res.data.message || STRINGS.cartError); return; }
        return fetchDrawerSection();
      })
      .catch(function () { window.location.href = ROUTES.cart_url; });
  }

  function initAddToCart() {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches || !form.matches('[data-cart-form]')) return;
      if (!window.fetch) return; /* fall back to a normal form POST */
      e.preventDefault();
      clearCartError();
      var btn = $('[data-add-to-cart]', form);
      if (btn) btn.setAttribute('aria-busy', 'true');
      var body = new FormData(form);
      body.append('sections', 'cart-drawer');
      fetch(ROUTES.cart_add_url, { method: 'POST', headers: { 'Accept': 'application/json' }, body: body })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
        .then(function (res) {
          if (btn) btn.removeAttribute('aria-busy');
          if (!res.ok) {
            showCartError(res.data.description || res.data.message || STRINGS.cartError, form);
            if (drawers.cart) drawers.cart.open(btn);
            return;
          }
          return fetchDrawerSection().then(function () {
            if (drawers.cart) drawers.cart.open(btn);
          });
        })
        .catch(function () { form.submit(); });
    });
  }

  /* ---------------- Header openers ---------------- */
  function initOpeners() {
    $$('[data-open-drawer]').forEach(function (btn) {
      if (btn.dataset.openerBound) return;
      btn.dataset.openerBound = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var key = btn.getAttribute('data-open-drawer');
        if (drawers[key]) drawers[key].open(btn);
      });
    });
  }

  /* ---------------- Facets auto-submit ---------------- */
  function initFacets() {
    var form = $('[data-facet-form]');
    if (!form) return;
    form.addEventListener('change', function (e) {
      if (e.target.matches('input[type="number"]')) return;
      form.submit();
    });
    $$('input[type="number"]', form).forEach(function (input) {
      input.addEventListener('change', function () { form.submit(); });
    });
    var sort = $('[data-sort-select]');
    if (sort) sort.addEventListener('change', function () { sort.form.submit(); });
  }

  /* ---------------- Boot ---------------- */
  function boot() {
    registerOverlay('cart', '#CartDrawer');
    registerOverlay('menu', '#MobileNav');
    registerOverlay('search', '#SearchModal');
    initReveal();
    initMegaMenu();
    initOpeners();
    initQuantity();
    initVariantPickers();
    initGallery();
    initFacets();
    initAddToCart();
    bindCartDrawer();
  }

  /* Content injected after load (product recommendations) must be re-initialised,
     otherwise its .an-reveal elements stay at opacity 0 forever. */
  function refresh(root) {
    var scope = root || document;
    initReveal(scope);
    initQuantity(scope);
    initVariantPickers(scope);
    initGallery(scope);
  }
  window.AlakhTheme = { refresh: refresh };
  document.addEventListener('alakh:recommendations', function (e) {
    refresh(e.detail && e.detail.section ? e.detail.section : document);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  /* Theme editor support */
  document.addEventListener('shopify:section:load', function (e) {
    initReveal(e.target); initQuantity(e.target); initVariantPickers(e.target);
    initGallery(e.target); initMegaMenu(); initOpeners(); bindCartDrawer();
    registerOverlay('cart', '#CartDrawer'); registerOverlay('menu', '#MobileNav'); registerOverlay('search', '#SearchModal');
  });
})();

/* Card image shuffle. Desktop cycles on hover; touch cycles while the card is
   in view, because there is no hover to engage with. Stops on leave and resets
   to the featured image so the grid never drifts out of sync with the label. */
(function () {
  var cards = document.querySelectorAll('[data-shuffle]');
  if (!cards.length) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var canHover = window.matchMedia('(hover: hover)').matches;

  cards.forEach(function (card) {
    var frames = card.querySelectorAll('[data-shuffle-frame]');
    var pips = card.querySelectorAll('.an-card__pip');
    if (!frames.length) return;
    var wait = parseInt(card.dataset.shuffleInterval, 10) || 1000;
    var timer = null, i = 0;

    function show(n) {
      frames.forEach(function (f, k) { f.classList.toggle('is-on', k === n - 1); });
      pips.forEach(function (p, k) { p.classList.toggle('is-on', k === n); });
    }
    function start() {
      if (reduce || timer) return;
      card.classList.add('is-shuffling');
      timer = setInterval(function () { i = (i + 1) % (frames.length + 1); show(i); }, wait);
    }
    function stop() {
      clearInterval(timer); timer = null; i = 0; show(0);
      card.classList.remove('is-shuffling');
    }

    if (canHover) {
      card.addEventListener('mouseenter', start);
      card.addEventListener('mouseleave', stop);
      card.addEventListener('focusin', start);
      card.addEventListener('focusout', stop);
    } else if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { e.isIntersecting && e.intersectionRatio > 0.6 ? start() : stop(); });
      }, { threshold: [0, 0.6] }).observe(card);
    }
  });
})();

/* Currency selector — submit on change, no separate Go button. */
(function () {
  document.querySelectorAll('[data-currency-select]').forEach(function (sel) {
    sel.addEventListener('change', function () { sel.form && sel.form.submit(); });
  });
})();

/* Stop playback when the gallery moves off a video slide — otherwise audio
   keeps running from a picture the customer can no longer see. */
(function () {
  var gallery = document.querySelector('[data-gallery]');
  if (!gallery) return;
  function pauseHidden() {
    gallery.querySelectorAll('.an-gallery__slide').forEach(function (slide) {
      if (slide.classList.contains('is-active')) return;
      slide.querySelectorAll('video').forEach(function (v) { if (!v.paused) v.pause(); });
      slide.querySelectorAll('iframe').forEach(function (f) {
        // Re-assigning src is the only reliable cross-provider stop.
        if (f.src) f.src = f.src;
      });
    });
  }
  new MutationObserver(pauseHidden).observe(gallery, {
    subtree: true, attributes: true, attributeFilter: ['class']
  });
})();

/* Predictive search ----------------------------------------------------
   The theme had none: the modal was a plain form, so nothing appeared until
   you submitted and landed on /search. Uses Shopify's suggest.json, which
   does prefix matching — 'mah' now matches 'Maharmah' rather than needing
   the whole title. Keyboard: arrows move, Enter opens, Escape closes. */
(function () {
  var input = document.querySelector('[data-psearch-input]');
  var panel = document.querySelector('[data-psearch]');
  var out = document.querySelector('[data-psearch-results]');
  var status = document.querySelector('[data-psearch-status]');
  if (!input || !panel || !out || !window.fetch) return;

  var limit = parseInt(input.dataset.limit, 10) || 6;
  var timer = null, controller = null, active = -1, term = '';

  function money(cents) {
    if (window.Shopify && Shopify.formatMoney) return Shopify.formatMoney(cents);
    return (cents / 100).toLocaleString(undefined, { minimumFractionDigits: 0 });
  }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function close() {
    panel.hidden = true; input.setAttribute('aria-expanded', 'false');
    out.innerHTML = ''; active = -1;
  }
  function items() { return out.querySelectorAll('[data-psearch-item]'); }

  function render(data) {
    var products = (data.resources.results.products || []).slice(0, limit);
    var collections = (data.resources.results.collections || []).slice(0, 3);
    if (!products.length && !collections.length) {
      out.innerHTML = '<p class="an-psearch__empty">No matches for &ldquo;' + esc(term) + '&rdquo;</p>';
      status.textContent = 'No results';
      panel.hidden = false; input.setAttribute('aria-expanded', 'true');
      return;
    }
    var html = '';
    if (products.length) {
      html += '<ul class="an-psearch__list" role="listbox">';
      products.forEach(function (p) {
        var img = p.featured_image && p.featured_image.url
          ? '<img src="' + p.featured_image.url.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') + '" alt="" loading="lazy">'
          : '<span class="an-psearch__noimg"></span>';
        html += '<li role="option" aria-selected="false"><a data-psearch-item href="' + p.url + '">'
             +  '<span class="an-psearch__thumb">' + img + '</span>'
             +  '<span class="an-psearch__meta"><span class="an-psearch__title">' + esc(p.title) + '</span>'
             +  '<span class="an-psearch__price">' + money(p.price_min) + '</span></span></a></li>';
      });
      html += '</ul>';
    }
    if (collections.length) {
      html += '<ul class="an-psearch__list an-psearch__list--plain" role="listbox">';
      collections.forEach(function (c) {
        html += '<li role="option" aria-selected="false"><a data-psearch-item href="' + c.url + '">'
             +  '<span class="an-psearch__title">' + esc(c.title) + '</span>'
             +  '<span class="an-psearch__tag">Collection</span></a></li>';
      });
      html += '</ul>';
    }
    html += '<a class="an-psearch__all" data-psearch-item href="/search?q=' + encodeURIComponent(term) + '">'
         +  'See all results for &ldquo;' + esc(term) + '&rdquo;</a>';
    out.innerHTML = html;
    status.textContent = products.length + ' suggestions';
    panel.hidden = false; input.setAttribute('aria-expanded', 'true');
    active = -1;
  }

  function query(q) {
    if (controller) controller.abort();
    controller = new AbortController();
    var url = '/search/suggest.json?q=' + encodeURIComponent(q)
            + '&resources[type]=product,collection'
            + '&resources[limit]=' + limit
            + '&resources[options][unavailable_products]=last'
            + '&resources[options][fields]=title,product_type,variants.title,vendor,tag';
    fetch(url, { signal: controller.signal })
      .then(function (r) { return r.json(); })
      .then(render)
      .catch(function (e) { if (e.name !== 'AbortError') close(); });
  }

  input.addEventListener('input', function () {
    term = input.value.trim();
    clearTimeout(timer);
    if (term.length < 2) { close(); return; }
    timer = setTimeout(function () { query(term); }, 180);
  });

  input.addEventListener('keydown', function (e) {
    var list = items();
    if (e.key === 'Escape') { close(); return; }
    if (!list.length) return;
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      e.preventDefault();
      active = e.key === 'ArrowDown'
        ? (active + 1) % list.length
        : (active <= 0 ? list.length - 1 : active - 1);
      list.forEach(function (el, i) {
        el.classList.toggle('is-active', i === active);
        if (el.parentElement.getAttribute('role') === 'option') {
          el.parentElement.setAttribute('aria-selected', i === active ? 'true' : 'false');
        }
      });
    } else if (e.key === 'Enter' && active > -1) {
      e.preventDefault(); list[active].click();
    }
  });

  document.addEventListener('click', function (e) {
    if (!panel.contains(e.target) && e.target !== input) close();
  });
})();
